import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';

export const ActionButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 9;

  > button {
    margin: 0 ${rem(spacing8)};
  }
`;
